import axios from 'axios';
import { fetchApiDataFailure } from '../_actions/common.actions';
import {
    fetchCollectionPdfsFailure,
    fetchCollectionPdfsRequest,
    fetchCollectionPdfsSuccess
} from '../_actions/pdf.links.actions';
import api from './api.services';

export const fetchPdfsByCollectionId = (collectionId) => dispatch => {
    dispatch(fetchCollectionPdfsRequest(collectionId));

    axios.get(api.get_pdfs_by_collection_id.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchCollectionPdfsSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchCollectionPdfsFailure(error));
            dispatch(fetchApiDataFailure(error));
        });
};



// WEBPACK FOOTER //
// ./src/_thunks/pdf.links.thunk.js